import React from 'react';
import Grid from '@material-ui/core/Grid';
import { FilterRenderer } from './FilterRenderer';
import { SortRenderer } from './SortRenderer';
import { $HeadGrid } from './styles';
export const HeadFilter = ({ props, type, onChange, onClickMenu, onSort, noFilterType, sortDirection, noSort, colKey, }) => {
    const handleSort = () => {
        if (onSort && !noSort) {
            onSort((sortDirection === 'ASC') ? 'DESC' : (sortDirection === 'DESC') ? undefined : 'ASC');
        }
    };
    const handleFilter = (value) => {
        if (onChange)
            onChange(value);
    };
    return (React.createElement($HeadGrid, { container: true, wrap: 'nowrap' },
        React.createElement(Grid, { container: true },
            React.createElement(SortRenderer, { handleSort: handleSort, columnName: props.column?.name, noSort: noSort, sortDirection: sortDirection }),
            React.createElement(FilterRenderer, { ...props, colKey: colKey, noSort: noSort, sortDirection: sortDirection, handleFilter: handleFilter, noFilterType: noFilterType, type: type, onClickMenu: onClickMenu }))));
};
export const HeadFilterCell = (props) => {
    const config = props.column.headFilter;
    if (!config)
        return null;
    return React.createElement(HeadFilter, { ...config, props: props });
};
